module.exports = __webpack_public_path__ + "static/img/13.6cf5c6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/13.png
// module id = 1+XK
// module chunks = 0